import React, { useEffect, useState } from "react";
import CodehouzeHeader from "../components/codehouze/CodehouzeHeader";
import CodehouzeHero from "../components/codehouze/CodehouzeHero";
import CodehouzeServices from "../components/codehouze/CodehouzeServices";
import CodehouzeWork from "../components/codehouze/CodehouzeWork";
import CodehouzeAbout from "../components/codehouze/CodehouzeAbout";
import CodehouzeContact from "../components/codehouze/CodehouzeContact";
import CodehouzeFooter from "../components/codehouze/CodehouzeFooter";
import StartProjectModal from "../components/codehouze/StartProjectModal";

function Codehouze() {
  const [isStartProjectOpen, setIsStartProjectOpen] = useState(false);

  useEffect(() => {
    document.title = "Codehouze Technology Solutions — Full-Stack Development & Consulting";
  }, []);

  return (
    <main className="text-gray-400 bg-gray-900 body-font">
      <CodehouzeHeader onStartProject={() => setIsStartProjectOpen(true)} />
      <CodehouzeHero onStartProject={() => setIsStartProjectOpen(true)} />
      <CodehouzeServices />
      <CodehouzeWork />
      <CodehouzeAbout />
      <CodehouzeContact />
      <CodehouzeFooter />
      <StartProjectModal
        isOpen={isStartProjectOpen}
        onClose={() => setIsStartProjectOpen(false)}
      />
    </main>
  );
}

export default Codehouze;
